import { trainStationCodeMap } from "@/config/trainStationCodeMap"
import flightPackCode from "@/config/flightPackCode"
import trainPackCode from "@/config/trainPackCode"
import { getPrestTotalPrice, getPriceAccommodationOnly } from "@/logic/pricesAndDiscount"

export default {
	totals: (state, getters) => {

		const selectedPrestations = getters.selectedPrestations

		const participants = state.participants

		let totalPrice = 0
		let crossedPrice = 0

		if (selectedPrestations.length > 0) {

			let origin = 'NA';
			if (flightPackCode.includes(state.packCode) || trainPackCode.includes(state.packCode)) {
				if (state.flightOrigin) {
					origin = state.flightOrigin;
				}
				else if (state.wiypDefaultFlightOrigin) {
					origin = state.wiypDefaultFlightOrigin;
				}
				else {
					origin = trainPackCode.includes(state.packCode) ? Array.from(trainStationCodeMap.keys())[0] : 'NA';
				}
			}

			let firstAccommodation = true;
			selectedPrestations.forEach((prestObj) => {
				// Here we may have a problem with the prestIdFusion and prestIdSource concerning virtual stock
				const wiypData = 
					getters.getWiypCallByFamilyCompositionAndOriginAndPackageCodeAndId(participants.join('-'), origin, state.packCode, prestObj.prestation.prestIdSource) ?? 
					getters.getWiypCallByFamilyCompositionAndOriginAndPackageCodeAndId(participants.join('-'), origin, state.packCode, prestObj.prestation.prestIdFusion) ?? 
					getters.getWiypCallByFamilyCompositionAndOriginAndPackageCodeAndId(participants.join('-'), origin, state.packCode, prestObj.prestation.prestId);

				const wiypPrice = wiypData?.wiypPrices?.find((w) => w.prestId === prestObj.prestation.prestIdSource);

				if (wiypPrice && wiypPrice.publicPriceWiyp && wiypPrice.sellingPriceWiyp && wiypPrice.accomPriceWiyp) {
					prestObj.prestation.crossedPrice = wiypPrice.sellingPriceWiyp;
					prestObj.prestation.maxPromo = Math.round(( wiypPrice.publicPriceWiyp - wiypPrice.sellingPriceWiyp) / wiypPrice.publicPriceWiyp * 100);
					prestObj.prestation.pricePerLogement = wiypPrice.sellingPriceWiyp;
					prestObj.prestation.pricePerPerson = wiypPrice.sellingPriceWiyp/participants.length;
					prestObj.prestation.priceAccommodationOnly = wiypPrice.accomPriceWiyp;
				}
				let quantity = prestObj.quantity
				if (firstAccommodation) {
					firstAccommodation = false;
					totalPrice += getPrestTotalPrice(prestObj.prestation);
					crossedPrice += prestObj.prestation.crossedPrice
					quantity -= 1;
				}
				if (prestObj.prestation.priceAccommodationOnly) {
					totalPrice += quantity * getPriceAccommodationOnly(prestObj.prestation);
				} else {
					totalPrice += quantity * getPrestTotalPrice(prestObj.prestation);
				}				
				crossedPrice += quantity * prestObj.prestation.crossedPrice;
			})
		}

		let perPrice = totalPrice / participants.length

		const obj = {}

		obj["totalPrice"] = totalPrice
		obj["perPrice"] = perPrice
		// Because of the wiyp pricing and priceAccommodationOnly, we don't need to calculate the global max promo, except for HS
		let maxPromo = parseInt((1 - totalPrice / crossedPrice) * 100)
		if (state.packCode =='HS' && maxPromo >= 5) obj["crossedPrice"] = crossedPrice
		if (state.packCode =='HS' && maxPromo >= 5) obj["maxPromo"] = maxPromo

		return obj
	}
}
